<template>
  <div class="home-dashboard">
    <!-- 欢迎标题 -->
    <div class="welcome-section">
      <h2 class="welcome-title">欢迎使用 {{this.$project.projectName}}</h2>
      <p class="welcome-subtitle">医院挂号预约数据概览</p>
    </div>

    <!-- 概览统计卡片 -->
    <el-row :gutter="20" class="stats-cards">
      <el-col :xs="12" :sm="12" :md="6">
        <div class="stat-card card-today">
          <div class="stat-icon"><i class="el-icon-date"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ stats.todayCount }}</div>
            <div class="stat-label">今日预约</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="6">
        <div class="stat-card card-confirmed">
          <div class="stat-icon"><i class="el-icon-circle-check"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ stats.confirmedCount }}</div>
            <div class="stat-label">已预约</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="6">
        <div class="stat-card card-cancelled">
          <div class="stat-icon"><i class="el-icon-circle-close"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ stats.cancelledCount }}</div>
            <div class="stat-label">已取消</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="6">
        <div class="stat-card card-total">
          <div class="stat-icon"><i class="el-icon-s-data"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ stats.totalCount }}</div>
            <div class="stat-label">总预约数</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 图表区域 -->
    <el-row :gutter="20" class="chart-row">
      <!-- 近一周预约趋势 -->
      <el-col :span="24">
        <div class="chart-card">
          <div class="chart-header">
            <h3>近一周预约趋势</h3>
            <span class="chart-desc">按状态分类统计</span>
          </div>
          <div id="week-chart" style="height:380px;"></div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="chart-row">
      <!-- 近半年月度预约趋势 -->
      <el-col :span="24">
        <div class="chart-card">
          <div class="chart-header">
            <h3>近半年月度预约趋势</h3>
            <span class="chart-desc">按月统计</span>
          </div>
          <div id="month-chart" style="height:360px;"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import router from '@/router/router-static'

export default {
  data() {
    return {
      stats: {
        todayCount: 0,
        confirmedCount: 0,
        cancelledCount: 0,
        totalCount: 0
      },
      weekChart: null,
      monthChart: null
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.$storage.get('Token')) {
        this.$http({
          url: `${this.$storage.get('sessionTable')}/session`,
          method: "get"
        }).then(({ data }) => {
          if (data && data.code != 0) {
            router.push({ name: 'login' })
          } else {
            this.loadAllData()
          }
        })
      } else {
        router.push({ name: 'login' })
      }
    },

    async loadAllData() {
      // 先初始化图表（确保DOM存在）
      this.$nextTick(() => {
        this.weekChart = this.$echarts.init(document.getElementById('week-chart'))
        this.monthChart = this.$echarts.init(document.getElementById('month-chart'))
        this.weekChart.setOption(this.getLoadingOption())
        this.monthChart.setOption(this.getLoadingOption())
      })

      try {
        // 获取全部预约数据，用于统计和图表
        const { data: pageRes } = await this.$http({
          url: '/yuyuexinxi/page',
          method: 'get',
          params: { page: 1, limit: 9999 }
        })
        const allList = (pageRes && pageRes.code === 0 && pageRes.data && pageRes.data.list) ? pageRes.data.list : []
        console.log('获取到预约数据条数:', allList.length)

        // 1. 统计卡片
        let confirmedCount = 0, cancelledCount = 0
        allList.forEach(item => {
          if (item.sfsh === '已预约') confirmedCount++
          else if (item.sfsh === '已取消') cancelledCount++
        })
        this.stats.confirmedCount = confirmedCount
        this.stats.cancelledCount = cancelledCount
        this.stats.totalCount = pageRes && pageRes.data ? (pageRes.data.total || allList.length) : allList.length

        // 今日预约
        const today = this.formatDate(new Date())
        this.stats.todayCount = allList.filter(item => item.yuyueshijian && String(item.yuyueshijian).substring(0, 10) === today).length

        // 2. 渲染近一周图表
        this.renderWeekChart(allList)

        // 3. 渲染近半年月度图表
        this.renderMonthChart(allList)

      } catch (e) {
        console.error('加载首页数据失败', e)
        this.weekChart && this.weekChart.setOption(this.getEmptyOption('加载失败'))
        this.monthChart && this.monthChart.setOption(this.getEmptyOption('加载失败'))
      }

      window.addEventListener('resize', () => {
        this.weekChart && this.weekChart.resize()
        this.monthChart && this.monthChart.resize()
      })
    },

    // ========== 近一周预约趋势 ==========
    renderWeekChart(allList) {
      if (!this.weekChart) return
      const today = new Date()
      today.setHours(0, 0, 0, 0)

      // 以今天为中心，前3天+今天+后3天 = 7天
      const dateRange = []
      for (let i = -3; i <= 3; i++) {
        const d = new Date(today)
        d.setDate(d.getDate() + i)
        dateRange.push(this.formatDate(d))
      }

      // 按日期和状态分组统计
      const dateMap = {}
      dateRange.forEach(d => {
        dateMap[d] = { confirmed: 0, cancelled: 0 }
      })

      allList.forEach(item => {
        if (item.yuyueshijian) {
          const itemDate = String(item.yuyueshijian).substring(0, 10)
          if (dateMap.hasOwnProperty(itemDate)) {
            if (item.sfsh === '已预约') dateMap[itemDate].confirmed++
            else if (item.sfsh === '已取消') dateMap[itemDate].cancelled++
          }
        }
      })

      const weekLabels = dateRange.map(d => {
        const parts = d.split('-')
        return parts[1] + '/' + parts[2]
      })
      const confirmedData = dateRange.map(d => dateMap[d].confirmed)
      const cancelledData = dateRange.map(d => dateMap[d].cancelled)

      this.weekChart.setOption({
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        legend: { data: ['已预约', '已取消'], top: 10 },
        grid: { left: '3%', right: '4%', bottom: '3%', top: 50, containLabel: true },
        xAxis: { type: 'category', data: weekLabels },
        yAxis: { type: 'value', minInterval: 1, name: '预约数量' },
        series: [
          {
            name: '已预约', type: 'bar', barWidth: '35%', data: confirmedData,
            itemStyle: { color: '#409EFF', borderRadius: [6, 6, 0, 0] },
            label: { show: true, position: 'top', color: '#409EFF', fontSize: 12 }
          },
          {
            name: '已取消', type: 'bar', barWidth: '35%', data: cancelledData,
            itemStyle: { color: '#F56C6C', borderRadius: [6, 6, 0, 0] },
            label: { show: true, position: 'top', color: '#F56C6C', fontSize: 12 }
          }
        ]
      })

      console.log('近一周日期范围:', dateRange)
      console.log('近一周统计数据:', dateMap)
    },

    // ========== 近半年月度预约趋势 ==========
    renderMonthChart(allList) {
      if (!this.monthChart) return
      const today = new Date()
      const monthMap = {}
      const monthKeys = []

      for (let i = 5; i >= 0; i--) {
        const d = new Date(today.getFullYear(), today.getMonth() - i, 1)
        const year = d.getFullYear()
        const month = String(d.getMonth() + 1).padStart(2, '0')
        const monthKey = year + '-' + month
        monthKeys.push(monthKey)
        monthMap[monthKey] = 0
      }

      allList.forEach(item => {
        if (item.yuyueshijian) {
          const dateStr = String(item.yuyueshijian).substring(0, 7)
          if (monthMap.hasOwnProperty(dateStr)) {
            monthMap[dateStr]++
          }
        }
      })

      const monthLabels = monthKeys.map(m => {
        const parts = m.split('-')
        return parts[0] + '年' + parseInt(parts[1]) + '月'
      })
      const monthData = monthKeys.map(m => monthMap[m] || 0)

      this.monthChart.setOption({
        tooltip: { trigger: 'axis' },
        legend: { data: ['预约总数'], top: 10 },
        grid: { left: '3%', right: '4%', bottom: '3%', top: 50, containLabel: true },
        xAxis: { type: 'category', boundaryGap: false, data: monthLabels },
        yAxis: { type: 'value', minInterval: 1, name: '预约数量' },
        series: [{
          name: '预约总数', type: 'line', smooth: true, data: monthData,
          itemStyle: { color: '#409EFF' },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(64,158,255,0.3)' },
              { offset: 1, color: 'rgba(64,158,255,0.05)' }
            ])
          },
          lineStyle: { width: 3 },
          symbol: 'circle', symbolSize: 10,
          label: { show: true, fontSize: 12 }
        }]
      })
    },

    // 加载中的图表
    getLoadingOption() {
      return {
        title: {
          text: '加载中...',
          left: 'center',
          top: 'center',
          textStyle: { color: '#999', fontSize: 14 }
        },
        xAxis: { show: false },
        yAxis: { show: false },
        series: []
      }
    },

    // 空数据图表
    getEmptyOption(text) {
      return {
        title: {
          text: text,
          left: 'center',
          top: 'center',
          textStyle: { color: '#999', fontSize: 16 }
        },
        xAxis: { show: false },
        yAxis: { show: false },
        series: []
      }
    },

    formatDate(date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return y + '-' + m + '-' + d
    },

  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {})
    this.weekChart && this.weekChart.dispose()
    this.monthChart && this.monthChart.dispose()
  }
}
</script>

<style lang="scss" scoped>
.home-dashboard {
  padding: 0;
  background: #f0f2f5;
  min-height: calc(100vh - 120px);

  .welcome-section {
    padding: 24px 0 8px;
    .welcome-title {
      margin: 0;
      font-size: 22px;
      font-weight: 600;
      color: #303133;
    }
    .welcome-subtitle {
      margin: 6px 0 0;
      font-size: 14px;
      color: #909399;
    }
  }

  .stats-cards {
    margin-bottom: 20px;
  }

  .stat-card {
    display: flex;
    align-items: center;
    padding: 24px 20px;
    border-radius: 10px;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    }

    .stat-icon {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 16px;
      font-size: 28px;
    }

    .stat-info {
      flex: 1;
      .stat-value {
        font-size: 32px;
        font-weight: 700;
        line-height: 1.2;
      }
      .stat-label {
        font-size: 14px;
        opacity: 0.85;
        margin-top: 4px;
      }
    }

    &.card-today {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    }
    &.card-confirmed {
      background: linear-gradient(135deg, #409EFF 0%, #36D1DC 100%);
    }
    &.card-cancelled {
      background: linear-gradient(135deg, #F56C6C 0%, #FF9966 100%);
    }
    &.card-total {
      background: linear-gradient(135deg, #67C23A 0%, #85CE61 100%);
    }
  }

  .chart-row {
    margin-bottom: 20px;
  }

  .chart-card {
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    margin-bottom: 0;

    .chart-header {
      display: flex;
      align-items: baseline;
      margin-bottom: 10px;
      h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
        color: #303133;
      }
      .chart-desc {
        margin-left: 12px;
        font-size: 12px;
        color: #909399;
      }
    }
  }
}
</style>
